import { TabsProps } from 'antd';

import { InsuranceTabKeys } from '../model/types';

export const tabsContent = (ordersNumber = 0): TabsProps['items'] => [
  {
    key: InsuranceTabKeys.MANUAL,
    label: 'Ввести вручну',
  },
  {
    key: InsuranceTabKeys.ORDER,
    label: `Мої придбані поліси (${ordersNumber})`,
  },
];

export const MAX_SELECTED_INSURANCE_ORDERS = 2;
